import React from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const PolicyDrawer: React.FC<Props> = ({ open, onClose, title, children }) => {
  return (
    <>
      {open && (
        <div className="fixed inset-0 z-40">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={onClose}
          />
          <div className="absolute right-0 top-0 h-full w-full max-w-lg bg-engramiq-dark-blue border-l border-white/30 z-50 flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-white/20">
              <h2 className="text-white text-lg font-semibold">{title}</h2>
              <button onClick={onClose} className="text-white/80 hover:text-white">✕</button>
            </div>
            <div className="p-4 text-white overflow-y-auto">
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PolicyDrawer;
